import script from "./AccountRegistrationModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccountRegistrationModal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__